import { render, staticRenderFns } from "./DocumentsSelection.vue?vue&type=template&id=1f908403&"
import script from "./DocumentsSelection.vue?vue&type=script&lang=js&"
export * from "./DocumentsSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports